import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhySection from './components/WhySection';
import CategoryGrid from './components/CategoryGrid';
import TrustSection from './components/TrustSection';
import SeoContentSection from './components/SeoContentSection';
import CtaSection from './components/CtaSection';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <WhySection />
      <CategoryGrid />

      {/* Quick CTA Between Sections */}
      <section className="py-10 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="font-heading text-2xl font-bold text-foreground-950 mb-2">
                Szukasz konkretnego produktu?
              </h3>
              <p className="text-sm text-foreground-500 max-w-md">
                Przeglądaj nasz Kakobuy Spreadsheet i znajdź dokładnie to, czego potrzebujesz. Codziennie nowe produkty!
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-7 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Kakobuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      </section>

      <TrustSection />

      {/* SEO Guides Section */}
      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-10">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
              Poradniki i przewodniki Kakobuy
            </h2>
            <p className="text-foreground-500 text-sm max-w-xl">
              Dowiedz się wszystkiego o Kakobuy Spreadsheet — od podstaw po zaawansowane strategie zakupowe
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Main Article Card */}
            <Link
              to="/artykul/kakobuy-sheet-kompletny-przewodnik"
              className="md:col-span-2 group bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="aspect-[16/7] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Person%20hands%20holding%20tablet%20device%20displaying%20colorful%20product%20comparison%20interface%20with%20shopping%20catalog%20items%20arranged%20on%20rustic%20wooden%20table%20with%20coffee%20cup%20and%20potted%20succulent%20plant%20overhead%20flatlay%20style%20bright%20natural%20daylight%20clean%20shadows%20modern%20lifestyle%20blogger%20photography%20aesthetic%20with%20warm%20beige%20and%20cream%20tones%20organized%20creative%20workspace&width=900&height=400&seq=kakobuy-guide-card-v2-2026&orientation=landscape"
                  alt="Kompletny przewodnik Kakobuy Sheet"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs text-accent-600 font-semibold tracking-wider uppercase">Poradnik</span>
                <h3 className="font-heading text-xl font-bold text-foreground-950 mt-2 mb-2">
                  Kakobuy Sheet — Kompletny Przewodnik 2026
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  Wszystko co musisz wiedzieć o Kakobuy Spreadsheet. Jak znaleźć najlepsze produkty, sprawdzić sprzedawców i zaoszczędzić na zakupach. Praktyczny przewodnik krok po kroku dla początkujących i zaawansowanych.
                </p>
                <div className="mt-4 flex items-center gap-2 text-sm text-primary-500 font-medium">
                  <span>Czytaj więcej</span>
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </div>
              </div>
            </Link>

            {/* Side cards */}
            <div className="space-y-6">
              <Link
                to="/artykul/kakobuy-qc-guide"
                className="block group bg-background-100 rounded-2xl p-5 hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                <span className="text-xs text-secondary-600 font-semibold tracking-wider uppercase">QC Guide</span>
                <h3 className="font-heading text-base font-bold text-foreground-950 mt-2 mb-1">
                  Jak sprawdzać jakość produktów?
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  Naucz się czytać zdjęcia QC i unikaj niskiej jakości produktów. 10 kluczowych elementów kontroli.
                </p>
              </Link>

              <Link
                to="/artykul/kakobuy-wysylka-do-polski"
                className="block group bg-background-100 rounded-2xl p-5 hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                <span className="text-xs text-secondary-600 font-semibold tracking-wider uppercase">Wysyłka</span>
                <h3 className="font-heading text-base font-bold text-foreground-950 mt-2 mb-1">
                  Dostawa do Polski — Poradnik
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  Najlepsze metody wysyłki, jak unikać ceł, koszty i porady — kompletny przewodnik.
                </p>
              </Link>

              <Link
                to="/artykul/kakobuy-porownanie-agentow"
                className="block group bg-background-100 rounded-2xl p-5 hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                <span className="text-xs text-secondary-600 font-semibold tracking-wider uppercase">Porównanie</span>
                <h3 className="font-heading text-base font-bold text-foreground-950 mt-2 mb-1">
                  Kakobuy vs inne platformy
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  Porównanie agentów zakupowych — który jest najlepszy dla Ciebie? Ranking i ceny.
                </p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <SeoContentSection />
      <CtaSection />

      {/* FAQ Section */}
      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-10 text-center">
            Najczęściej zadawane pytania
          </h2>
          <div className="space-y-3">
            {[
              {
                q: 'Czym jest Kakobuy Spreadsheet?',
                a: 'Kakobuy Spreadsheet to regularnie aktualizowany arkusz zawierający listę sprawdzonych produktów, linki do sprzedawców, ceny oraz zdjęcia QC. To narzędzie, które pomaga szybko znaleźć najlepsze produkty bez konieczności samodzielnego przeszukiwania setek ofert.',
              },
              {
                q: 'Czy Kakobuy Spreadsheet jest darmowy?',
                a: 'Tak, nasz Kakobuy Spreadsheet jest całkowicie darmowy. Wystarczy wejść na stronę kaspreadsheet.com i przeglądać dostępne kategorie produktów.',
              },
              {
                q: 'Jak często aktualizowany jest arkusz?',
                a: 'Aktualizujemy Kakobuy Spreadsheet codziennie. Dodajemy nowe produkty, usuwamy niedostępne oferty i weryfikujemy sprzedawców, aby zapewnić najwyższą jakość informacji.',
              },
              {
                q: 'Czy produkty są wysyłane do Polski?',
                a: 'Tak, większość produktów z naszego arkusza może być wysłana do Polski. W naszych poradnikach znajdziesz szczegółowe informacje na temat metod wysyłki, ceł i podatków.',
              },
              {
                q: 'Jak znaleźć konkretny produkt w arkuszu?',
                a: 'Nasz arkusz jest podzielony na kategorie — buty, bluzy, koszulki, akcesoria i wiele więcej. Wystarczy wybrać interesującą Cię kategorię i przeglądać dostępne produkty. Możesz też skorzystać z wyszukiwarki na stronie.',
              },
            ].map((faq, idx) => (
              <details key={idx} className="group bg-background-50 rounded-xl">
                <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{faq.q}</span>
                  <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                </summary>
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      {/* Schema.org FAQPage JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Czym jest Kakobuy Spreadsheet?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Kakobuy Spreadsheet to regularnie aktualizowany arkusz zawierający listę sprawdzonych produktów, linki do sprzedawców, ceny oraz zdjęcia QC. To narzędzie, które pomaga szybko znaleźć najlepsze produkty bez konieczności samodzielnego przeszukiwania setek ofert."
              }
            },
            {
              "@type": "Question",
              "name": "Czy Kakobuy Spreadsheet jest darmowy?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Tak, nasz Kakobuy Spreadsheet jest całkowicie darmowy. Wystarczy wejść na stronę kaspreadsheet.com i przeglądać dostępne kategorie produktów."
              }
            },
            {
              "@type": "Question",
              "name": "Jak często aktualizowany jest arkusz?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Aktualizujemy Kakobuy Spreadsheet codziennie. Dodajemy nowe produkty, usuwamy niedostępne oferty i weryfikujemy sprzedawców, aby zapewnić najwyższą jakość informacji."
              }
            },
            {
              "@type": "Question",
              "name": "Czy produkty są wysyłane do Polski?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Tak, większość produktów z naszego arkusza może być wysłana do Polski. W naszych poradnikach znajdziesz szczegółowe informacje na temat metod wysyłki, ceł i podatków."
              }
            },
            {
              "@type": "Question",
              "name": "Jak znaleźć konkretny produkt w arkuszu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Nasz arkusz jest podzielony na kategorie — buty, bluzy, koszulki, akcesoria i wiele więcej. Wystarczy wybrać interesującą Cię kategorię i przeglądać dostępne produkty. Możesz też skorzystać z wyszukiwarki na stronie."
              }
            }
          ]
        })}
      </script>
    </main>
  );
}